import { render, staticRenderFns } from "./DocumentTypeForm.vue?vue&type=template&id=be6c3f5a"
import script from "./DocumentTypeForm.vue?vue&type=script&lang=js"
export * from "./DocumentTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports